import { useQuery } from '@tanstack/react-query';
import { tagsApi } from '@/lib/api';
import type { Tag } from '@/types/database';

export const tagKeys = {
  all: ['tags'] as const,
  lists: () => [...tagKeys.all, 'list'] as const,
  list: () => [...tagKeys.lists()] as const,
};

export function useTags() {
  return useQuery({
    queryKey: tagKeys.list(),
    queryFn: async (): Promise<Tag[]> => {
      return await tagsApi.getAll();
    },
  });
}
